<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.merchant')"
    :onFetchData="onFetchData"
    resource="merchants"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { abilityService } from 'beans-admin-plugin';
import _ from 'lodash';

@Component
export default class Merchants extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  provenanceCascaderData = []

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('merchant.name'),
        renderCell: {
          component: 'input'
         }
      },
      {
        prop: 'en_name_cont',
        label: this.$t('merchant.enName'),
        renderCell: {
          component: 'input'
         }
      }
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'logo',
        label: this.$t('merchant.logo'),
        width: 120,
        renderCell: 'storageAttachment',
      },
      {
        prop: 'name',
        label: this.$t('merchant.name'),
      },
      {
        prop: 'en_name',
        label: this.$t('merchant.enName'),
      },
      type === 'show' && {
        prop: 'contact',
        label: this.$t('merchant.contact'),
      },
      type === 'show' && {
        prop: 'phone',
        label: this.$t('merchant.phone'),
      },
      type === 'show' && {
        prop: 'email',
        label: this.$t('merchant.email'),
      },
      type === 'show' && {
        prop: 'wechat',
        label: this.$t('merchant.wechat'),
      },
      {
        prop: 'merchant_category_id',
        label: this.$t('model.merchantCategory'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.merchant_category) {
            const name = row.merchant_category.name
            if (abilityService.can('merchant_categories.read')) {
              return <router-link to={{ name: 'merchant_categories.show', params: { id: row.merchant_category_id } }}>{name}</router-link>
            } else {
              return <span>{name}</span>
            }
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'province_id',
        label: this.$t('model.province'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.province) {
            const name = row.province.name

            return <span>{name}</span>
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'city_id',
        label: this.$t('model.city'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.city) {
            const name = row.city.name

            return <span>{name}</span>
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'provenance_id',
        label: this.$t('model.provenance'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.provenance) {
            const name = row.provenance.name
            if (abilityService.can('provenances.read')) {
              return <router-link to={{ name: 'provenances.show', params: { id: row.provenance_id } }}>{name}</router-link>
            } else {
              return <span>{name}</span>
            }
          } else {
            return <span>/</span>
          }
        },
      },
      type === 'show' && {
        prop: 'street',
        label: this.$t('merchant.street'),
      },
      type === 'show' && {
        prop: 'latitude',
        label: this.$t('merchant.latitude'),
      },
      type === 'show' && {
        prop: 'longitude',
        label: this.$t('merchant.longitude'),
      },
      type === 'show' && {
        prop: 'website',
        label: this.$t('merchant.website'),
      },
      {
        prop: 'winery_tour',
        label: this.$t('merchant.wineryTour'),
        renderCell: 'bool',
      },
      {
        prop: 'likes_count',
        label: this.$t('merchant.likesCount'),
      },
      type === 'show' && {
        prop: 'mini_program_path',
        label: this.$t('merchant.miniProgramPath'),
      },
      type === 'show' && {
        prop: 'share_desc',
        label: this.$t('merchant.shareDesc'),
      },
      type === 'show' && {
        prop: 'share_image',
        label: this.$t('merchant.shareImage'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'poster_image',
        label: this.$t('merchant.posterImage'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'images',
        label: this.$t('merchant.images'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'introduction',
        label: this.$t('merchant.introduction'),
        action: ['hide-in-table'],
        renderCell: 'html',
      },
      type === 'show' && {
        prop: 'created_at',
        label: this.$t('createdAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
      type === 'show' && {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
    ].filter(Boolean)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'logo',
        label: this.$t('merchant.logo'),
        width: 120,
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 104x104`,
          props: {
            cropper: {
              width: 104,
              height: 104
            }
          }
        }
      },
      {
        prop: 'name',
        label: this.$t('merchant.name'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'en_name',
        label: this.$t('merchant.enName'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'contact',
        label: this.$t('merchant.contact'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'phone',
        label: this.$t('merchant.phone'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'email',
        label: this.$t('merchant.email'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'wechat',
        label: this.$t('merchant.wechat'),
        renderCell: {
          component: 'input',
        },
      },
      {
        prop: 'merchant_category_id',
        label: this.$t('model.merchantCategory'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/merchant_categories', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/merchant_categories', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      },
      {
        prop: 'provenance_id_and_city_id',
        label: this.$t('merchant.provenanceAndCity'),
        renderCell: {
          required: true,
          component: 'el-cascader',
          props: {
            options: _.map(this.provenanceCascaderData, (provenance) => {
              return { value: provenance.id, label: provenance.name, children: _.map(provenance.cities, (city) => {
                  return { value: city.id, label: city.name }
                })
              }
            }),
          }
        }
      },
      {
        prop: 'street',
        label: this.$t('merchant.street'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'latitude',
        label: this.$t('merchant.latitude'),
        renderCell: {
          required: true,
          component: 'input',
          props: {
            type: 'number'
          }
        },
      },
      {
        prop: 'longitude',
        label: this.$t('merchant.longitude'),
        renderCell: {
          required: true,
          component: 'input',
          props: {
            type: 'number'
          }
        },
      },
      {
        prop: 'website',
        label: this.$t('merchant.website'),
        renderCell: {
          component: 'input',
        },
      },
      {
        prop: 'winery_tour',
        label: this.$t('merchant.wineryTour'),
        renderCell: {
          component: 'switch',
        },
      },
      {
        prop: 'share_desc',
        label: this.$t('merchant.shareDesc'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'share_image',
        label: this.$t('merchant.shareImage'),
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 500:400`,
          props: {
            cropper: {
              width: 500,
              height: 400
            }
          }
        }
      },
      {
        prop: 'poster_image',
        label: this.$t('merchant.posterImage'),
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 600x509`,
          props: {
            cropper: {
              width: 600,
              height: 509
            }
          }
        }
      },
      {
        prop: 'images',
        label: this.$t('merchant.images'),
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 750x422`,
          props: {
            limit: 9,
            cropper: {
              width: 750,
              height: 422
            }
          }
        }
      },
      {
        prop: 'introduction',
        label: this.$t('merchant.introduction'),
        renderCell: {
          component: 'editor',
        }
      },
    ]
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'merchants.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'merchants.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/merchants', { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'new' || type === 'edit') {
      this.provenanceCascaderData = await this.$request.get('/provenances?page=0');
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/merchants/${this.$route.params.id}`);

      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }

}

export const route = [
  {
    path: '/merchants',
    name: 'merchants.index',
    component: Merchants,
    props: {
      type: 'index',
    }
  },
  {
    path: '/merchants/new',
    name: 'merchants.new',
    component: Merchants,
    props: {
      type: 'new',
    }
  },
  {
    path: '/merchants/:id',
    name: 'merchants.show',
    component: Merchants,
    props: {
      type: 'show',
    }
  },
  {
    path: '/merchants/:id/edit',
    name: 'merchants.edit',
    component: Merchants,
    props: {
      type: 'edit'
    }
  }
]
</script>
